type ExtractParam<Path, NextPart> = Path extends `:${infer Param}`
  ? Record<Param, string> & NextPart
  : NextPart

type ExtractParams<Path> = Path extends `${infer Segment}/${infer Rest}`
  ? ExtractParam<Segment, ExtractParams<Rest>>
  : ExtractParam<Path, object>

export const createPathUtil = <
  RouteConfigType extends ReadonlyArray<{
    name: string
    path: string
  }>,
>(
  routeConfig: RouteConfigType,
) => {
  return <V extends RouteConfigType[number]['name']>(
    name: V,
    routeParams: ExtractParams<Extract<RouteConfigType[number], { name: V }>['path']>,
  ): string => {
    const routeObject = routeConfig.find((route) => route.name === name)!

    if (routeParams === undefined) {
      return routeObject.path
    }

    const paramNames = Object.keys(routeParams)

    const generatedPath = paramNames.reduce((acc, paramName) => {
      // @ts-expect-error
      return acc.replace(`:${paramName}`, routeParams[paramName])
    }, routeObject.path)

    return generatedPath
  }
}
